import React, { useEffect } from 'react';
import { BsShieldCheck } from "react-icons/bs";
import { authenticatedUserAddress, network } from '../../services/auth';
import { clientNetwork, deruptExtensionRegistrationAddress, devPrincipal, interfaceExtensionsFileName, stacksApi } from '../../lib/constants';
import axios from 'axios';
import { callReadOnlyFunction, cvToJSON, cvToValue, hexToCV } from '@stacks/transactions';
import { save } from '../../services/stacks';

const RegisteredExtensions = ({ recomendedExtensions, interfaceExtensions, registeredExtensions, setRegisteredExtensions, setInterfaceExtensions, page, setPage, setErrorMsg, setOpenSnackBar }) => {
    const authUser = authenticatedUserAddress({ network: clientNetwork });

    async function addExtension(extension) {
        if (!interfaceExtensions.some((ext) => ext.name === extension.name)) {
            const data = [...interfaceExtensions, extension];
            setInterfaceExtensions(data);
            save(
                { fileName: interfaceExtensionsFileName, content: JSON.stringify(data) },
                { encrypt: false, verify: false }
            ).then((res) => {
                console.log('saving userExtensions.json', { res });
                if (res?.success) {
                    // Use alert to notify user of changes applied
                    setErrorMsg({ severity: 'success', msg: 'Extension added successfully!' });
                    setOpenSnackBar(true);
                } else {
                    setInterfaceExtensions(interfaceExtensions.filter((ext) => ext.name !== extension.name));
                    setErrorMsg({ severity: 'error', msg: 'Error adding extension!' });
                    setOpenSnackBar(true);
                }
            });
        }
    }

    async function loadMore() {
        let res = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/contract/${deruptExtensionRegistrationAddress}/events?limit=5&offset=${page}`)).data?.results;
        res = await Promise.all(res.map(async ({ tx_id, contract_log: { contract_id, value: { hex } } }) => {
            const contractInfo = cvToJSON(hexToCV(hex))?.value;
            const extensionAddress = contractInfo?.["ext-contract"]?.value;
            const getMetaData = cvToValue(await callReadOnlyFunction({
                contractAddress: extensionAddress.split('.')[0],
                contractName: extensionAddress.split('.')[1],
                functionName: 'get-ext-metadata',
                functionArgs: [],
                network: network({ network: clientNetwork }),
                senderAddress: authUser
            }))?.value;
            const metaJson = (await axios.get(getMetaData?.description?.value)).data;
            return { ...metaJson, ...getMetaData, address: extensionAddress };
        }))
        console.log({ res });
        setRegisteredExtensions(prev => [...prev, ...res]);
        setPage(prev => prev + 5);
    }

    useEffect(() => {
        if (page === 0) {
            loadMore();
        }
    }, [])

    const authuser = authenticatedUserAddress({ network: clientNetwork });
    if (authuser !== devPrincipal) {
        return;
    }

    return (
        <div className="ext-grid">
            {registeredExtensions.map((extension, i) => {
                console.log(extension);
                if (!extension) return

                return (
                    <div className="ext-card" key={i}>
                        {recomendedExtensions.includes(extension.address) ? <BsShieldCheck className="recommended-badge" color='#FFF' /> : null}
                        <img src={extension.image.value} alt={extension.name.value} className="ext-card-image" />
                        <div className="ext-card-content">
                            <h3 className="ext-card-title">{extension.name.value}</h3>
                            <p className="ext-card-description">{extension.info}</p>
                            <button
                                className="ext-card-button add"
                                onClick={() => addExtension(extension)}
                                disabled={interfaceExtensions.some((ext) => ext.address === extension.address)}
                            >
                                {interfaceExtensions.some((ext) => ext.name.value === extension.name.value) ? 'Added' : 'Add'}
                            </button>
                        </div>
                    </div>
                )
            })

            }
        </div>
    );
};

export default RegisteredExtensions;